/**
 * Direct S3 upload helpers for large APK files (bypasses API body/proxy limits).
 */

export async function sha256HexFromFile(file) {
  const buffer = await file.arrayBuffer()
  const hash = await crypto.subtle.digest('SHA-256', buffer)
  return [...new Uint8Array(hash)]
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}

export function uploadApkToPresignedUrl(file, uploadUrl, onUploadProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', uploadUrl)
    xhr.setRequestHeader('Content-Type', 'application/vnd.android.package-archive')
    xhr.upload.onprogress = (event) => {
      if (onUploadProgress && event.lengthComputable) {
        onUploadProgress({
          loaded: event.loaded,
          total: event.total,
        })
      }
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve()
        return
      }
      reject(new Error(`S3 upload failed with status ${xhr.status}`))
    }
    xhr.onerror = () => reject(new Error('S3 upload failed'))
    xhr.send(file)
  })
}
